import { ensureSubsetOfKeys } from '@daymade/common-lib/types';
import { z } from 'zod';
import { zodSelectInvitedBy } from '../generated/zodSchemas.generated';

export const ZInvitedBySelect = zodSelectInvitedBy
  .pick({
    inviteeId: true,
    inviterId: true,
    createdAt: true,
    bonusScheme: true,
    status: true,
    inviterGracePeriodExpiresAt: true,
    inviteeGracePeriodExpiresAt: true,
  })
  .extend(
    ensureSubsetOfKeys(zodSelectInvitedBy.shape, {
      createdAt: z.coerce.date(),
      inviterGracePeriodExpiresAt: z.coerce.date().nullable(),
      inviteeGracePeriodExpiresAt: z.coerce.date().nullable(),
    }),
  );

export type TInvitedBySelect = z.infer<typeof ZInvitedBySelect>;
